var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStorage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#1E81F7",
    width: "40px",
    height: "40px",
    viewBox: "1 1 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2,21a1,1,0,0,0,1,1H21a1,1,0,0,0,1-1V18H2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11,2H3A1,1,0,0,0,2,3V16h9ZM9,10a1,1,0,0,1-2,0V8A1,1,0,0,1,9,8Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21,2H13V16h9V3A1,1,0,0,0,21,2Zm-4,8a1,1,0,0,1-2,0V8a1,1,0,0,1,2,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorage);
export default __webpack_public_path__ + "static/media/storage.ee70dfe7d93bfa36568783adedadbf17.svg";
export { ForwardRef as ReactComponent };